import { Auth } from 'aws-amplify';
import axios from 'axios';

const lambda = async (body, auth = 'cognito') => {
	const endpoint = body.endpoint;

	try {
		let response;

		if (auth === 'cognito') {
			const federatedToken = Cache.getItem('federatedToken');
			const Authorization = federatedToken?.id_token
				? federatedToken.id_token
				: (await Auth.currentSession()).getIdToken()?.jwtToken;
			const url =
				'https://a0youn41a1.execute-api.us-east-2.amazonaws.com/default/api';
			response = await axios.post(url, body, {
				headers: {
					Authorization,
					'Access-Control-Allow-Origin': '*',
				},
			});
		} else if (auth === 'apiKey') {
			const configMode = 'DEV';
			const Authorization =
				process.env[`REACT_APP_${configMode}_LAMBDADATACALLSKEY`];
			const url =
				'https://f096mzqyo7.execute-api.us-east-2.amazonaws.com/default/api';
			response = await axios.post(url, body, {
				headers: {
					Authorization,
				},
			});
		}
		return response?.data;
	} catch (error) {
		throw error;
	}
};

export const CreateContact = async (data) => {
	// Default options are marked with *
	return new Promise((resolve, reject) => {
		lambda({ endpoint: 'erinfree-create-hubspot-contact', variables: data })
			.then((res) => res.json())
			.then((result) => {
				resolve(result);
			});
	});
};

export const UpdateContact = async (data) => {
	// Default options are marked with *
	return new Promise((resolve, reject) => {
		lambda({ endpoint: 'update-hubspot-contact', variables: data })
			.then((res) => res.json())
			.then((result) => {
				resolve(result);
			});
	});
};
